module.exports = __webpack_public_path__ + "fonts/f9c3797f-895f-42e2-9e83-9340081311d6.72b27c47.woff";